/*
 * Copyright (c) 2012-present Sedicii Innovations Ltd.
 *
 * All rights reserved.
 */

window.SERVER_DATA = window.SERVER_DATA || {}

export default {
  'RELYING_PARTY_ID': window.SERVER_DATA.REACT_APP_RELYING_PARTY_ID || process.env.REACT_APP_RELYING_PARTY_ID,
  'CLIENT_ID': window.SERVER_DATA.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID,
  'CLIENT_SECRET': window.SERVER_DATA.REACT_APP_CLIENT_SECRET || process.env.REACT_APP_CLIENT_SECRET,
  'RECAPTCHA_SITE_KEY': window.SERVER_DATA.REACT_APP_RECAPTCHA_SITE_KEY || process.env.REACT_APP_RECAPTCHA_SITE_KEY
}
